module.exports = {
    /**
     * @private
     */
    isMouseDown: false,

    /**
     * @private
     */
    handlers: {
        onmousedown:  "onmousedown",
        onmouseleave: "onmouseleave",
        onmouseup:    "onmouseup",
        onmousemove:  "onmousemove"
    },

    /**
     * @private
     */
    mouseDrag: false,

    /**
     * @param    {enyo.Control}  sender  The sender
     * @param    {Object}        event   The event
     * @private
     */
    onmousedown: function(sender, event) {
        this.isMouseDown = true;
        this.mouseX      = event.pageX;
        this.mouseY      = event.pageY;
    },

    /**
     * @private
     */
    onmouseleave: function() {
        this.isMouseDown = false;
        this.mouseX      = null;
        this.mouseY      = null;
    },

    /**
     * @private
     */
    onmouseup: function() {
        this.isMouseDown = false;
        this.mouseX      = null;
        this.mouseY      = null;
    },

    /**
     * @param    {enyo.Control}  sender  The sender
     * @param    {Object}        event   The event
     * @private
     */
    onmousemove: function(sender, event) {
        var dx,
            dy;

        if (this.isMouseDown) {
            dx = event.pageX - this.mouseX;
            dy = event.pageY - this.mouseY;

            this.snapBy(-dx, -dy);

            this.mouseX = event.pageX;
            this.mouseY = event.pageY;
        }
    }
};
